import React from "react";

const CashIcon = ({ fill = "#7C3AED" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3335 4H2.66683C1.93045 4 1.3335 4.59695 1.3335 5.33333V10.6667C1.3335 11.403 1.93045 12 2.66683 12H13.3335C14.0699 12 14.6668 11.403 14.6668 10.6667V5.33333C14.6668 4.59695 14.0699 4 13.3335 4Z"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99984 9.33335C8.73622 9.33335 9.33317 8.7364 9.33317 8.00002C9.33317 7.26364 8.73622 6.66669 7.99984 6.66669C7.26346 6.66669 6.6665 7.26364 6.6665 8.00002C6.6665 8.7364 7.26346 9.33335 7.99984 9.33335Z"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 8H4.00667M12 8H12.0067"
        stroke="#7C3AED"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CashIcon;
